module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400-216edb96b562c79adc09e2d3c63db7c0.svg";